import React, { useState } from 'react';
import './Login.css';
import logo from '../../assets/image/logo.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');


  const showToast = (icon, title,text) => {
    MySwal.fire({
      toast: true,
      position: 'center',
      icon: icon,
      text:text,
      title: title,
      showConfirmButton: false,
      timer: 2000,
      timerProgressBar: true,
    });
  };

  const handleForgetPassword = async (e) => {
    e.preventDefault();

    if (!email) {
      showToast('error','Erroe' ,'Email is required');

      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      showToast('error','Erroe' ,'Email a valid email');

      return;
    }

    try {
      const res = await axios.post('https://apifrwrd.smplyrefer.com/api/forget_password', { email });

      if (res.data.success) {
      showToast('success','Success' ,'Reset link sent to your email');
        
        setTimeout(() => {
          navigate('/');
        }, 4000);
      } else {
      showToast('error','Error' ,res.data.message || 'Something went wrong');

      }
    } catch (error) {
      console.error(error);
      showToast('error','Error' ,error.response?.data?.message || 'Server error');

    }
  };

  return (

    <>
    <div className="page-wrapper">
      <div className="logo-container">
        <img src={logo} alt="logo" className="login-logo" />
      </div>

      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h2 className="login-title">Forget Password</h2>
          </div>

          <form className="login-form" onSubmit={handleForgetPassword}>
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter the email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <button type="submit" className="login-button">Send Reset Link</button>
          </form>
        </div>
      </div>

      <div className="logo-container">
        <span>www.frwrdtutors.com</span>
      </div>
    </div>
    </>

  );
};

export default ForgetPassword;
